import { Button } from '@workspace/ui/components/button';
import { ArrowRight, Building2, Rocket } from 'lucide-react';
import { useState } from 'react';
import { m } from '~/paraglide/messages.js';

export type BusinessType = 'from-scratch' | 'existing';

type Props = {
  onNext: (businessType: BusinessType) => void;
};

type OptionCardProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
};

function OptionCard({
  icon,
  title,
  description,
  isSelected,
  onClick,
}: OptionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group relative flex flex-col items-start gap-3 rounded-xl border p-6 text-left transition-all hover:bg-gray-900 focus:outline-none focus:ring-2 ${
        isSelected
          ? 'border-[#e4e4e7] bg-[#e4e4e7]/10'
          : 'border-gray-800 hover:border-gray-700'
      }`}
    >
      <div
        className={`transition-colors ${
          isSelected
            ? 'text-[#e4e4e7]'
            : 'text-gray-400 group-hover:text-[#e4e4e7]'
        }`}
      >
        {icon}
      </div>
      <div className="space-y-1">
        <h3 className="text-lg font-semibold text-white">{title}</h3>
        <p className="text-sm text-gray-400">{description}</p>
      </div>
    </button>
  );
}

export function WelcomeComponent({ onNext }: Props) {
  const [selectedType, setSelectedType] = useState<BusinessType | null>(null);

  const handleContinue = () => {
    if (selectedType) {
      onNext(selectedType);
    }
  };

  return (
    <div className="max-w-md flex items-center justify-center p-4">
      <div className="w-full max-w-2xl space-y-8">
        <div className="grid gap-4 sm:grid-cols-2">
          <OptionCard
            icon={<Rocket className="h-8 w-8" />}
            title={m['organization.welcome.option_1_title']()}
            description={m['organization.welcome.option_1_description']()}
            isSelected={selectedType === 'from-scratch'}
            onClick={() => setSelectedType('from-scratch')}
          />

          <OptionCard
            icon={<Building2 className="h-8 w-8" />}
            title={m['organization.welcome.option_2_title']()}
            description={m['organization.welcome.option_2_description']()}
            isSelected={selectedType === 'existing'}
            onClick={() => setSelectedType('existing')}
          />
        </div>

        <Button
          onClick={handleContinue}
          disabled={!selectedType}
          className="flex w-full items-center justify-center gap-2 rounded-lg  px-6 py-6 font-semibold transition-all disabled:cursor-not-allowed disabled:opacity-50"
        >
          {m['common.continue']()}
          <ArrowRight className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
}
